import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { TooltipModule } from 'primeng/tooltip';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { NgShowDirective } from '../../directives/ng-show/ng-show.directive';
import { NgClass } from '@angular/common';

@Component({
    selector: 'field-type-configurate-oauth',
    templateUrl: './field-type-configurate-oauth.component.html',
    standalone: true,
    imports: [NgClass, NgShowDirective, AfTranslateDirective, TooltipModule, AfTranslatePipe]
})
export class FieldTypeConfigurateOauthComponent implements OnChanges {
  constructor(private commonUtilsService: CommonUtilsService) { }
  @Input() field: any = null;
  @Input() oauthUser: any;
  @Output() itemSelected = new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['field'] && changes['field'].currentValue) {
        this.field.id = !this.field.id? this.commonUtilsService.createId() : this.field.id;
    }
  }

  initAuth(){
    this.itemSelected.emit({option: 'initAuth'});
  }

  deleteOauth(){
    this.itemSelected.emit({option: 'deleteOauth'});
  }
}


